import { render } from "./RegistrationPrintView.vue?vue&type=template&id=64054231"
import script from "./RegistrationPrintView.vue?vue&type=script&lang=js"
export * from "./RegistrationPrintView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__